import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Zalogowano");
      navigate("/admin");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6] grain flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-block mb-12 font-display text-2xl text-[#2B2B2B]">
          Agnieszka <span className="text-[#8A9A86]">Sendlewska</span>
        </Link>
        <div className="bg-white border border-[#E5E0D8] rounded-2xl p-10 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
          <p className="text-overline mb-4">Panel administracyjny</p>
          <h1 className="font-display text-3xl text-[#2B2B2B] mb-8">Logowanie</h1>
          <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
            <div>
              <label className="text-overline block mb-2">Email</label>
              <input
                type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
                className="w-full bg-transparent border-b border-[#E5E0D8] py-3 focus:outline-none focus:border-[#8A9A86] transition-colors"
              />
            </div>
            <div>
              <label className="text-overline block mb-2">Hasło</label>
              <input
                type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
                className="w-full bg-transparent border-b border-[#E5E0D8] py-3 focus:outline-none focus:border-[#8A9A86] transition-colors"
              />
            </div>
            <button
              type="submit" disabled={submitting} data-testid="login-submit"
              className="w-full bg-[#2B2B2B] text-white rounded-full px-8 py-4 hover:bg-[#8A9A86] transition-colors disabled:opacity-50"
            >
              {submitting ? "Logowanie…" : "Zaloguj się"}
            </button>
          </form>
        </div>
        <Link to="/" className="block text-center mt-6 text-sm text-[#5C6670] hover:text-[#8A9A86]">
          ← Wróć do strony
        </Link>
      </div>
    </div>
  );
}
